module.exports = __webpack_public_path__ + "media/assets/images/landing/недвижимость-7d2fceb8bd39db09e35524d7b3c0fb9c.png";